import { go } from 'oderon-vue'
// import { delay } from 'oderon-commons/src/utils'

export const Paperman = {
  async findAndCount(ps) {
    return await go('GET', '/paperman/history', {
      ...ps,
      count: true
    })
  }
}
